<template>
  <v-dialog v-model="dialog" width="900px">
    <v-card>
      <p class=".title ma-2">SMS to / from the Host(s)</p>
      <v-form ref="huovHostSms">

      <v-row v-for="(sms, i) in huov.sms" :key="i" no-gutters class="mx-1">
        <v-col>
           <v-row no-gutters>
             <v-col cols=3>
            {{ sms.sms_dt}} 
             </v-col>
          <v-col cols=3>
             {{ sms.sms_direction}} 
             </v-col>
           <v-col cols=3>
             Status: {{ sms.sms_status}} 
             </v-col>  
           </v-row>
           <v-row no-gutters>  
             <v-col cols=12>
               <v-textarea :value=sms.sms_tekst rows="2"></v-textarea>
             </v-col>    
           </v-row>  
        </v-col>
      </v-row>

      <!--
        <v-simple-table dense>
          <template v-slot:default>
            <tbody>
              <tr
                v-for="(sms, i) in huov.sms"
                :key="i"
              >
                <td>{{ sms.sms_dt }}</td>
                <td>{{ sms.sms_tekst }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        -->
      </v-form>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" small @click="dialog = false">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() { 
    return {
      dialog: false,
      huov_encrid: null,
      huov: {},
    }
  },
  methods: {
    open(huov_encrid) {
      this.$emit("showSnackbar");
      this.dialog = true;
      this.$axios
        .post("ares/json/ares/huov/getHuovHostSms.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getHuovHostSms",
          },
          getHuovHostSms: {
            huov_encrid: huov_encrid,
          },
        })
        .then((res) => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.huov = res.data.getHuovHostSms;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

